/* import __COLOCATED_TEMPLATE__ from './react-adapter.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { dropTask } from 'ember-concurrency-decorators';
import { inject as service } from '@ember/service';
import type ArrayProxy from '@ember/array/proxy';
import type SdkApp from 'embercom/models/sdk-app';
import type SdkAppService from 'embercom/services/sdk-app-service';
import type Store from '@ember-data/store';
import { hash } from 'ember-concurrency';
import { taskFor } from 'ember-concurrency-ts';
import type AppService from 'embercom/services/app-service';
import type ReactTeammateAppIslandService from 'embercom/services/react-teammate-app-island';
import { registerDestructor } from '@ember/destroyable';

export interface Args {}

export default class ReactAdapter extends Component<Args> {
  @service declare sdkAppService: SdkAppService;
  @service declare store: Store;
  @service declare appService: AppService;
  @service declare reactTeammateAppIsland: ReactTeammateAppIslandService;

  constructor(owner: unknown, args: Args) {
    super(owner, args);

    taskFor(this.loadMessengerInstallData).perform();

    let unsubscribeFieldChangeHandler = this.reactTeammateAppIsland.subscribeToTeammateAppEvent(
      'data-sync-fields-changed',
      () => {
        this.appService.app.reload();
      },
    );

    registerDestructor(this, unsubscribeFieldChangeHandler);
  }

  get hasLoadedMessengerInstallData(): boolean {
    return !!taskFor(this.loadMessengerInstallData)?.lastComplete;
  }

  @dropTask *loadMessengerInstallData() {
    // Load SDK apps logic copied from intercom-messenger route
    let sdkApps = this.store.peekAll('sdk-app') as ArrayProxy<SdkApp>;
    let iosSdkApp = sdkApps.find((sdkApp) => sdkApp.platform === 'iOS');
    let androidSdkApp = sdkApps.find((sdkApp) => sdkApp.platform === 'Android');

    if (iosSdkApp && androidSdkApp) {
      this.sdkAppService.initWithSdkApps(iosSdkApp, androidSdkApp);
    }

    yield hash({
      sdkApps:
        iosSdkApp && androidSdkApp
          ? [iosSdkApp, androidSdkApp]
          : taskFor(this.sdkAppService.loadSdkApps).perform(),
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Adapters::ReactAdapter': typeof ReactAdapter;
    'standalone/adapters/react-adapter': typeof ReactAdapter;
  }
}
